// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__QZXym","title":"InfoRow_title__3uJtN"};